






















































































































































































import { ContactApi } from "../api/ContactApi";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import ContactListFilters from "./ContactListPartials/ContactListFilters.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import ClientArchiveModal from "./ClientArchiveModal.vue";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import _ from "lodash";

export default {
    name: "ContactList",
    components: {
        ExportButton,
        Pagination,
        PerPage,
        ContactListFilters,
        AutoRefresh,
        ClientArchiveModal,
    },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            clients: [],
            ContactApi: new ContactApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            showArchiveModal: false,
            archiveModalClient: null,
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "adresse,coordonnees",
                sort: this.sort,
                showArchived: true,
                useCache: false,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.ContactApi.getAll(params)
                .then(function (response) {
                    let { data, paginator } = response;
                    self.clients = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    return self.clients;
                })
                .catch(function (error) {
                    self.clients = [];
                    console.error("Error loading clients:", error);
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        refreshClients() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        getExportParams() {
            return _.assign(
                { sort: this.sort, showArchived: true },
                this.filters
            );
        },
        editClient(client) {
            window.location.href = client.link;
        },
        deleteClient(client) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                `Voulez vous supprimer le client ${client.nom} ?`,
                "Ses dossiers du journal, ses facturations, ses interventions planifiées et à venir, ses états des lieux, ses audits, ses relances et ses documents partent avec lui à la corbeille, puis sont supprimés définitivement au terme du délai de conservation. Pour conserver ces données, archivez plutôt le client."
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.ContactApi.delete(client.id, raison).then(
                    function () {
                        swal("Client supprimé !", "", "success");
                        self.refreshClients();
                    },
                    function (error) {
                        // 422 : { message }, 403 : { error: { message } }
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    }
                );
            });
        },
        archiveClient(client) {
            this.archiveModalClient = client;
            this.showArchiveModal = true;
        },
        restoreClient(client) {
            let self = this;
            client.archived = false;
            self.ContactApi.save(client).then(function () {
                self.refreshClients();
            });
        },
        onArchiveModalClose() {
            this.showArchiveModal = false;
            this.archiveModalClient = null;
        },
        onConfirmArchive(data) {
            let self = this;
            const { client, endDate } = data;

            let formattedDate = null;
            let successMessage = `Le client ${client.nom} a été archivé avec succès.`;

            if (endDate) {
                // Convert date from DD/MM/YYYY to YYYY-MM-DD
                const dateParts = endDate.split('/');
                formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                successMessage += ` Les interventions récurrentes ont été terminées au ${endDate}.`;
            } else {
                successMessage += ` Les interventions récurrentes restent inchangées.`;
            }

            // Archive the client with optional end date for recurring interventions
            self.ContactApi.archiveWithEndDate(client.id, formattedDate).then(function (updatedClient) {
                // Update the client in the list
                const clientIndex = self.clients.findIndex(c => c.id === client.id);
                if (clientIndex !== -1) {
                    self.clients[clientIndex] = updatedClient;
                }

                self.onArchiveModalClose();
                swal("Client archivé !", successMessage, "success");
            }).catch(function (error) {
                console.error("Error archiving client:", error);
                swal("Erreur", "Une erreur est survenue lors de l'archivage du client.", "error");
            });
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
